// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const PaymentIntentTypes = {
    EventRegistration: {
        Name: 'Event Registration',
        Value: 'event_registration',
    },
}